import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DisplayModes } from '../../../models/enums';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';
import { HelperMethodsService } from '../../../services/helper-methods.service';
import { BusinessUnitService } from '../../business-unit/business-unit.service';
import { ReportsColConfigService } from '../reports-col-config.service';

@Component({
  selector: 'crm-manag-reports-col-config',
  templateUrl: './manag-reports-col-config.component.html',
  styleUrls: ['./manag-reports-col-config.component.css']
})
export class ManagReportsColConfigComponent implements OnInit {

  displayMode: DisplayModes = DisplayModes.Success;
  configurations :any[] = [];
  @Output() closeEvent = new EventEmitter<boolean>();
  @Input() reportName: string="";

  constructor(private readonly reportsColConfigService: ReportsColConfigService,
    private readonly route: ActivatedRoute, private readonly helperMethods: HelperMethodsService,
    private readonly router: Router, private businessUnitService: BusinessUnitService,
    private readonly translateService: AppTranslationService,
    private readonly alertService: AlertService) { }

  ngOnInit() {
 
    if (this.reportName != undefined)
      this.getReportConfigDetails(this.reportName);
  }

  getReportConfigDetails(reportName:string) {
    this.displayMode = DisplayModes.Loading;
    this.reportsColConfigService.getByReportName(reportName).subscribe(responce => {
      this.displayMode = DisplayModes.Success;
      this.configurations = responce as any[];

    },
      err => {
        this.displayMode = DisplayModes.Error;
        console.log('error in get Report Config Details');
        console.log(err);
      });
  }

  save() {
      this.displayMode = DisplayModes.Loading;

    let data = {
      reportName: this.reportName,
      configurations: this.configurations
    }
      this.alertService.startLoadingMessage("", this.translateService.getTranslation("Saving"));
    this.reportsColConfigService.save(data).subscribe(() => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Success;
        this.back();
        this.alertService.showMessage("", this.translateService.getTranslation("clm.savedSuccessfully"), MessageSeverity.Success);
      }, () => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Error;
      });
  
  }




  back() {
    this.closeEvent.emit(true);
  }

}
